/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-07-12 17:03:33
 * @LastEditors: xiawenlong
 * @LastEditTime: 2025-12-30 11:15:11
 */
import Vue from 'vue'
import Modal from 'ant-design-vue/lib/modal'
import Pagination from 'ant-design-vue/lib/pagination'
import 'ant-design-vue/dist/antd.css'

import App from './App.vue'
import router from './router'
import dataV from '@jiaminghi/data-view'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
import { Progress, Table, Tabs } from 'ant-design-vue'
Vue.use(Progress)
Vue.use(Table)
Vue.use(Tabs)
import './assets/common.scss'
Vue.component(Modal.name, Modal)
Vue.component(Pagination.name, Pagination)

Vue.use(dataV)
Vue.config.productionTip = false
import VueParticles from 'vue-particles'
Vue.use(VueParticles)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
